<template>
    <div class="main">
        <div class="main-header container">
            <ainak-header/>
        </div>
        <div class="main-content container">
            <home-content/>
        </div>
        <div class="main-footer">
            <ainak-footer/>
        </div>

        <b-modal :active.sync="isNewUser" class="new-user-modal" @close="handleOutsideClick">
            <div class="new-modal-content">
                <h1>Hurray!! </h1>
                <h1>Your account is ready to go!!! </h1>
                <h2>Lets watch a 2 minute video to get you started </h2>
                <vue-plyr class="video-player" :canCancel="cancel">
                    <div data-plyr-provider="youtube" data-plyr-embed-id="8o2myNsHyOo"></div>
                </vue-plyr>
                <h3> Dont want to watch? Click anywhere outside to get started!</h3>
            </div>
        </b-modal>
        <home-tour></home-tour>

    </div>
</template>

<script>
    import HomeContent from "@/components/Home/HomeContent.vue";
    import AinakHeader from "../components/AinakHeader";
    import AinakFooter from "../components/AinakFooter";
    import HomeTour from '@/components/SiteTour/HomeTour'
    export default {
        name: "Home",
        data: function () {
            return {
                image: require('@/assets/images/img-vr.png'),
                isNewUser: true,
                cancel:['escape', 'x']
            }
        },
        components: {
            AinakFooter,
            AinakHeader,
            HomeContent,
            HomeTour
        },
        computed: {
            showTut() {
                return this.$store.getters.getShowTut;
            }
        },
        mounted(){
            this.checkifLoggedIn(),            
            this.showTutorial()
        },
        methods: {
            checkifLoggedIn(){
                console.log("loggedin: ",this.$store.state._user_authenticated);
                if(!this.$store.state._user_authenticated){
                    this.$router.push('Login');
                }
            },
            handleOutsideClick(){
                console.log("I am closed");
                this.$tours['myTour'].start()
            },
            showTutorial(){
                console.log("show tut: ",this.$store.getters.getShowTut)
                this.isNewUser = this.$store.getters.getShowTut;
            }
        }
    };
</script>

<style lang="scss" scoped>

    @import '@/assets/css/colors.scss';

    %top-padding-width-height {
        width: 100%;
        height: 100%;
        top: 0;
    }

    %flex-center-content {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .main {
        @extend %top-padding-width-height;
        display: grid;
        grid-template-areas: "main-header" "main-content" "main-footer";
        grid-template-rows: 10% 85% 5%;
        grid-template-columns: 1fr;
        overflow: hidden;
        margin:  0;

        .main-header {
            @extend %flex-center-content;
        }

        .main-content {
            grid-area: main-content;
            background-color: $bg-color;
            @extend %top-padding-width-height;
            overflow: hidden;
        }

        .main-footer{
            grid-area: main-footer;
            display: flex;
            justify-content: center;
            flex-direction: column;
            background-color: #f5f5f5;
        }
    }

    .new-modal-content{
        padding: 5% 2%;
        overflow: hidden;
        border-radius: 5%;
        background-color: white;

        h1{
            font-family: 'Roboto Slab', sans-serif;
            font-size: 200%;
            width: 100%;
        }
        h2{
            font-family: 'Roboto', sans-serif;
            font-size: 100%;
            width: 100%;
            color: $body-text-color;
        }
        .video-player{
            margin: 2% 0;
        }

        h3{
            font-family: 'Roboto', sans-serif;
            font-size: 80%;
            padding: 1%;
            border-radius: 10px;
            cursor: pointer;
        }
    }


</style>
